import { getFirstMonth, type Months } from '@psw/shared';
export class TaxonMonth {
  months: Months;

  constructor(months: Months) {
    this.months = months;
  }

  get lastYearRange() {
    return [getFirstMonth(this.months), this.months[this.months.length - 1]];
  }

  static isRangeLastYear(range: number[], taxonMonth: TaxonMonth) {
    const lastYearRange = taxonMonth.lastYearRange;
    return range[0] === lastYearRange[0] && range[1] === lastYearRange[1];
  }
}
